// This is a generated file (see: utilities/extractEnums/readme.md for details)
export var previousProblems;
(function (previousProblems) {
    previousProblems["none"] = "none";
    previousProblems["depression"] = "depression";
    previousProblems["anxiety"] = "anxiety";
    previousProblems["panic"] = "panic";
    previousProblems["socialAnxiety"] = "socialAnxiety";
    previousProblems["trauma"] = "trauma";
    previousProblems["mania"] = "mania";
    previousProblems["disorderedEating"] = "disorderedEating";
    previousProblems["substanceUseProblems"] = "substanceUseProblems";
    previousProblems["hyperactivityAttentionDeficit"] = "hyperactivityAttentionDeficit";
    previousProblems["psychosis"] = "psychosis";
    previousProblems["obsessionsCompulsions"] = "obsessionsCompulsions";
    previousProblems["autismSpectrum"] = "autismSpectrum";
    previousProblems["personalityDisorderTraits"] = "personalityDisorderTraits";
})(previousProblems || (previousProblems = {}));
export var previousConditions;
(function (previousConditions) {
    previousConditions["seizureDisorder"] = "seizureDisorder";
    previousConditions["cardiovascularDisease"] = "cardiovascularDisease";
    previousConditions["sleepProblems"] = "sleepProblems";
    previousConditions["liverDisease"] = "liverDisease";
    previousConditions["thyroidDisease"] = "thyroidDisease";
    previousConditions["sensoryMotorImpairment"] = "sensoryMotorImpairment";
    previousConditions["headTrauma"] = "headTrauma";
    previousConditions["cancer"] = "cancer";
    previousConditions["weightAppetiteChange"] = "weightAppetiteChange";
    previousConditions["renalDiseaseSymptoms"] = "renalDiseaseSymptoms";
    previousConditions["asthmaLungDisease"] = "asthmaLungDisease";
    previousConditions["sexualDysfunction"] = "sexualDysfunction";
    previousConditions["hypertension"] = "hypertension";
    previousConditions["autoimmuneDisease"] = "autoimmuneDisease";
    previousConditions["pregnant"] = "pregnant";
})(previousConditions || (previousConditions = {}));
export var appearance;
(function (appearance) {
    appearance["wellGroomed"] = "wellGroomed";
    appearance["disheveled"] = "disheveled";
    appearance["inappropriate"] = "inappropriate";
})(appearance || (appearance = {}));
export var rapport;
(function (rapport) {
    rapport["cooperative"] = "cooperative";
    rapport["defensive"] = "defensive";
    rapport["hostile"] = "hostile";
    rapport["demanding"] = "demanding";
    rapport["distrustful"] = "distrustful";
})(rapport || (rapport = {}));
export var behavior;
(function (behavior) {
    behavior["normal"] = "normal";
    behavior["agitated"] = "agitated";
    behavior["restless"] = "restless";
    behavior["impulsive"] = "impulsive";
    behavior["slowedLethargic"] = "slowedLethargic";
    behavior["tics"] = "tics";
})(behavior || (behavior = {}));
export var speech;
(function (speech) {
    speech["normal"] = "normal";
    speech["rapid"] = "rapid";
    speech["pressured"] = "pressured";
    speech["slurred"] = "slurred";
})(speech || (speech = {}));
export var affect;
(function (affect) {
    affect["appropriate"] = "appropriate";
    affect["constricted"] = "constricted";
    affect["labile"] = "labile";
    affect["blunted"] = "blunted";
    affect["flat"] = "flat";
})(affect || (affect = {}));
export var mood;
(function (mood) {
    mood["euthymic"] = "euthymic";
    mood["depressed"] = "depressed";
    mood["anxious"] = "anxious";
    mood["angry"] = "angry";
    mood["irritable"] = "irritable";
    mood["euphoric"] = "euphoric";
})(mood || (mood = {}));
export var thoughtProcess;
(function (thoughtProcess) {
    thoughtProcess["linearGoalDirected"] = "linearGoalDirected";
    thoughtProcess["tangential"] = "tangential";
    thoughtProcess["circumstantial"] = "circumstantial";
    thoughtProcess["flightOfIdeas"] = "flightOfIdeas";
})(thoughtProcess || (thoughtProcess = {}));
export var thoughtContentPerceptions;
(function (thoughtContentPerceptions) {
    thoughtContentPerceptions["normal"] = "normal";
    thoughtContentPerceptions["ruminations"] = "ruminations";
    thoughtContentPerceptions["suicidalThoughts"] = "suicidalThoughts";
    thoughtContentPerceptions["obsessions"] = "obsessions";
    thoughtContentPerceptions["compulsions"] = "compulsions";
    thoughtContentPerceptions["derealization"] = "derealization";
    thoughtContentPerceptions["reExperiencing"] = "reExperiencing";
    thoughtContentPerceptions["hallucinations"] = "hallucinations";
    thoughtContentPerceptions["delusions"] = "delusions";
})(thoughtContentPerceptions || (thoughtContentPerceptions = {}));
export var cognition;
(function (cognition) {
    cognition["normalFullyOriented"] = "normalFullyOriented";
    cognition["confused"] = "confused";
    cognition["drowsy"] = "drowsy";
    cognition["memoryImpairment"] = "memoryImpairment";
    cognition["attentionImpairment"] = "attentionImpairment";
})(cognition || (cognition = {}));
export var insight;
(function (insight) {
    insight["good"] = "good";
    insight["fair"] = "fair";
    insight["poor"] = "poor";
})(insight || (insight = {}));
export var judgement;
(function (judgement) {
    judgement["good"] = "good";
    judgement["fair"] = "fair";
    judgement["poor"] = "poor";
})(judgement || (judgement = {}));
export var classification;
(function (classification) {
    classification["primary"] = "primary";
    classification["secondary"] = "secondary";
})(classification || (classification = {}));
export var riskLevels;
(function (riskLevels) {
    riskLevels["notApplicable"] = "notApplicable";
    riskLevels["notElevated"] = "notElevated";
    riskLevels["low"] = "low";
    riskLevels["medium"] = "medium";
    riskLevels["high"] = "high";
})(riskLevels || (riskLevels = {}));
export { riskLevels as riskForHarmToSelf };
export { riskLevels as riskForHarmToOthers };
export var risks;
(function (risks) {
    risks["suicidalIdeation"] = "suicidalIdeation";
    risks["homicidalIdeation"] = "homicidalIdeation";
    risks["childAbuse"] = "childAbuse";
    risks["suicideAttempt"] = "suicideAttempt";
    risks["tarasoffIssue"] = "tarasoffIssue";
    risks["childNeglect"] = "childNeglect";
    risks["selfInjuriousBehavior"] = "selfInjuriousBehavior";
    risks["adultDependentAbuse"] = "adultDependentAbuse";
})(risks || (risks = {}));
export var primaryTherapeuticApproaches;
(function (primaryTherapeuticApproaches) {
    primaryTherapeuticApproaches["cognitiveBehavioralTherapy"] = "cognitiveBehavioralTherapy";
    primaryTherapeuticApproaches["emotionFocusedTherapy"] = "emotionFocusedTherapy";
    primaryTherapeuticApproaches["clientCenteredTherapy"] = "clientCenteredTherapy";
    primaryTherapeuticApproaches["interpersonalTherapy"] = "interpersonalTherapy";
    primaryTherapeuticApproaches["dialecticBehavioralTherapy"] = "dialecticBehavioralTherapy";
    primaryTherapeuticApproaches["acceptanceAndCommitmentTherapy"] = "acceptanceAndCommitmentTherapy";
    primaryTherapeuticApproaches["cognitiveBehavioralTherapyInsomnia"] = "cognitiveBehavioralTherapyInsomnia";
    primaryTherapeuticApproaches["prolongedExposureTherapy"] = "prolongedExposureTherapy";
    primaryTherapeuticApproaches["cognitiveProcessingTherapy"] = "cognitiveProcessingTherapy";
    primaryTherapeuticApproaches["acceleratedResolutionTherapy"] = "acceleratedResolutionTherapy";
    primaryTherapeuticApproaches["eyeMovementDesensitizationAndReprocessing"] = "eyeMovementDesensitizationAndReprocessing";
    primaryTherapeuticApproaches["traumaFocusedCBT"] = "traumaFocusedCBT";
    primaryTherapeuticApproaches["psychodynamicTherapy"] = "psychodynamicTherapy";
    primaryTherapeuticApproaches["motivationalInterviewing"] = "motivationalInterviewing";
    primaryTherapeuticApproaches["solutionFocusedTherapy"] = "solutionFocusedTherapy";
    primaryTherapeuticApproaches["problemSolvingTherapy"] = "problemSolvingTherapy";
    primaryTherapeuticApproaches["parentChildInteractionTherapy"] = "parentChildInteractionTherapy";
    primaryTherapeuticApproaches["mindfulnessBasedTherapies"] = "mindfulnessBasedTherapies";
    primaryTherapeuticApproaches["twelveStepFacilitation"] = "twelveStepFacilitation";
    primaryTherapeuticApproaches["smartRecoveryFacilitation"] = "smartRecoveryFacilitation";
    primaryTherapeuticApproaches["exposureAndResponsePrevention"] = "exposureAndResponsePrevention";
    primaryTherapeuticApproaches["medicationManagement"] = "medicationManagement";
})(primaryTherapeuticApproaches || (primaryTherapeuticApproaches = {}));
export var plannedFrequencyOfEngagementWithClient;
(function (plannedFrequencyOfEngagementWithClient) {
    plannedFrequencyOfEngagementWithClient["oncePerWeek"] = "oncePerWeek";
    plannedFrequencyOfEngagementWithClient["twicePerWeek"] = "twicePerWeek";
    plannedFrequencyOfEngagementWithClient["onceEveryTwoWeeks"] = "onceEveryTwoWeeks";
    plannedFrequencyOfEngagementWithClient["oncePerMonth"] = "oncePerMonth";
    plannedFrequencyOfEngagementWithClient["onceEveryTwoMonths"] = "onceEveryTwoMonths";
    plannedFrequencyOfEngagementWithClient["onceEveryThreeMonths"] = "onceEveryThreeMonths";
    plannedFrequencyOfEngagementWithClient["onceEverySixMonths"] = "onceEverySixMonths";
})(plannedFrequencyOfEngagementWithClient || (plannedFrequencyOfEngagementWithClient = {}));
export var plannedFollowUpOfMedManagementEngagementWithClient;
(function (plannedFollowUpOfMedManagementEngagementWithClient) {
    plannedFollowUpOfMedManagementEngagementWithClient["inOneWeek"] = "inOneWeek";
    plannedFollowUpOfMedManagementEngagementWithClient["inTwoWeeks"] = "inTwoWeeks";
    plannedFollowUpOfMedManagementEngagementWithClient["inOneMonth"] = "inOneMonth";
    plannedFollowUpOfMedManagementEngagementWithClient["inTwoMonths"] = "inTwoMonths";
    plannedFollowUpOfMedManagementEngagementWithClient["inThreeMonths"] = "inThreeMonths";
    plannedFollowUpOfMedManagementEngagementWithClient["inSixMonths"] = "inSixMonths";
    plannedFollowUpOfMedManagementEngagementWithClient["notApplicable"] = "notApplicable";
})(plannedFollowUpOfMedManagementEngagementWithClient || (plannedFollowUpOfMedManagementEngagementWithClient = {}));
export var noteType;
(function (noteType) {
    noteType["adultTherapyIntake"] = "adultTherapyIntake";
    noteType["adultTherapyFollowUp"] = "adultTherapyFollowUp";
    noteType["couplesFamilyTherapyIntake"] = "couplesFamilyTherapyIntake";
    noteType["couplesFamilyTherapyFollowUp"] = "couplesFamilyTherapyFollowUp";
    noteType["minorTherapyIntake"] = "minorTherapyIntake";
    noteType["minorTherapyFollowUp"] = "minorTherapyFollowUp";
    noteType["providerUnscheduled"] = "providerUnscheduled";
    noteType["careNavigatorUnscheduled"] = "careNavigatorUnscheduled";
    noteType["careNavigatorInitial"] = "careNavigatorInitial";
    noteType["careNavigatorFollowUp"] = "careNavigatorFollowUp";
    noteType["adultMedManagementIntake"] = "adultMedManagementIntake";
    noteType["adultMedManagementFollowUp"] = "adultMedManagementFollowUp";
    noteType["minorMedManagementIntake"] = "minorMedManagementIntake";
    noteType["minorMedManagementFollowUp"] = "minorMedManagementFollowUp";
    noteType["medManagerUnscheduled"] = "medManagerUnscheduled";
})(noteType || (noteType = {}));
export var appointmentMethod;
(function (appointmentMethod) {
    appointmentMethod["telehealth"] = "telehealth";
    appointmentMethod["inPerson"] = "inPerson";
})(appointmentMethod || (appointmentMethod = {}));
export var appointmentStatus;
(function (appointmentStatus) {
    appointmentStatus["completed"] = "completed";
    appointmentStatus["notAttended"] = "notAttended";
    appointmentStatus["lateCancel"] = "lateCancel";
})(appointmentStatus || (appointmentStatus = {}));
export var usedSubstance;
(function (usedSubstance) {
    usedSubstance["alcohol"] = "alcohol";
    usedSubstance["nicotine"] = "nicotine";
    usedSubstance["caffeine"] = "caffeine";
    usedSubstance["cannabis"] = "cannabis";
    usedSubstance["inhalants"] = "inhalants";
    usedSubstance["opioids"] = "opioids";
    usedSubstance["sedativesBenzodiazepines"] = "sedativesBenzodiazepines";
    usedSubstance["ecstasy"] = "ecstasy";
    usedSubstance["amphetaminesMethamphetamine"] = "amphetaminesMethamphetamine";
    usedSubstance["cocaine"] = "cocaine";
    usedSubstance["otherStimulants"] = "otherStimulants";
    usedSubstance["hallucinogens"] = "hallucinogens";
    usedSubstance["overTheCounterMedications"] = "overTheCounterMedications";
    usedSubstance["other"] = "other";
})(usedSubstance || (usedSubstance = {}));
export var alcoholFrequency;
(function (alcoholFrequency) {
    alcoholFrequency["none"] = "none";
    alcoholFrequency["lessThanOnePerWeek"] = "lessThanOnePerWeek";
    alcoholFrequency["oneTo5DrinksPerWeek"] = "oneTo5DrinksPerWeek";
    alcoholFrequency["sixToTenDrinksPerWeek"] = "sixToTenDrinksPerWeek";
    alcoholFrequency["elevenToFourteenDrinksPerWeek"] = "elevenToFourteenDrinksPerWeek";
    alcoholFrequency["fifteenPlusDrinksPerWeek"] = "fifteenPlusDrinksPerWeek";
    alcoholFrequency["bingeDrinking"] = "bingeDrinking";
    alcoholFrequency["blackoutHistory"] = "blackoutHistory";
})(alcoholFrequency || (alcoholFrequency = {}));
export var nicotineFrequency;
(function (nicotineFrequency) {
    nicotineFrequency["none"] = "none";
    nicotineFrequency["twoOrMoreTimesADay"] = "twoOrMoreTimesADay";
    nicotineFrequency["onceADay"] = "onceADay";
    nicotineFrequency["threeOrMoreTimesAWeek"] = "threeOrMoreTimesAWeek";
    nicotineFrequency["oneOrTwoTimesAWeek"] = "oneOrTwoTimesAWeek";
    nicotineFrequency["lessThanWeekly"] = "lessThanWeekly";
})(nicotineFrequency || (nicotineFrequency = {}));
export var caffeineFrequency;
(function (caffeineFrequency) {
    caffeineFrequency["none"] = "none";
    caffeineFrequency["oneToTwoCupsDaily"] = "oneToTwoCupsDaily";
    caffeineFrequency["threeToFourCupsDaily"] = "threeToFourCupsDaily";
    caffeineFrequency["fiveOrMoreCupsDaily"] = "fiveOrMoreCupsDaily";
})(caffeineFrequency || (caffeineFrequency = {}));
export var cannabisFrequency;
(function (cannabisFrequency) {
    cannabisFrequency["none"] = "none";
    cannabisFrequency["twoOrMoreTimesADay"] = "twoOrMoreTimesADay";
    cannabisFrequency["onceADay"] = "onceADay";
    cannabisFrequency["threeOrMoreTimesAWeek"] = "threeOrMoreTimesAWeek";
    cannabisFrequency["oneToTwoTimesAWeek"] = "oneToTwoTimesAWeek";
    cannabisFrequency["lessThanOnceAWeek"] = "lessThanOnceAWeek";
})(cannabisFrequency || (cannabisFrequency = {}));
